import { createContext } from 'react';

import type { TMessageConfig } from '@client/types';

export const NotificationContext = createContext({
  modalApi: null,
  messageApi: null,
  notificationApi: null,
} as unknown as Partial<TMessageConfig>);
